import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import RoleDisplay from '../role-display';
type UpdateOrgMemberProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const UpdateOrgMember = t0 => {
  const $ = _c(33);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.update"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "update_org_member") {
    return null;
  }
  const {
    firstName,
    lastName,
    oldRole,
    newRole
  } = detail.data;
  let t2;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t2 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== firstName || $[7] !== lastName || $[8] !== t) {
    t4 = firstName && lastName ? `${firstName} ${lastName}'s` : t(_temp3);
    $[6] = firstName;
    $[7] = lastName;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <span className="text-label-2 text-primary">{t4}</span>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t(_temp4);
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <span className="text-body-2 text-tertiary">{t6}</span>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== oldRole.name || $[17] !== oldRole.scopes) {
    t8 = <RoleDisplay name={oldRole.name} scopes={oldRole.scopes} />;
    $[16] = oldRole.name;
    $[17] = oldRole.scopes;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t(_temp5);
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <span className="text-body-2 text-tertiary">{t9}</span>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== newRole.name || $[24] !== newRole.scopes) {
    t11 = <RoleDisplay name={newRole.name} scopes={newRole.scopes} />;
    $[23] = newRole.name;
    $[24] = newRole.scopes;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t3 || $[29] !== t5 || $[30] !== t7 || $[31] !== t8) {
    t12 = <>{t3}{t5}{t7}{t8}{t10}{t11}</>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t3;
    $[29] = t5;
    $[30] = t7;
    $[31] = t8;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default UpdateOrgMember;
function _temp($) {
  return $.updated;
}
function _temp2($_0) {
  return $_0.updated;
}
function _temp3($_1) {
  return $_1.aMemberS;
}
function _temp4($_2) {
  return $_2.roleFrom;
}
function _temp5($_3) {
  return $_3.to;
}